import * as React from 'react'
import controlStore from '../../store/controlStore.ts'
import historyStore from '../../store/historyStore.ts'
import mapStore from '../../store/mapStore.ts'
import { GoogleMapWrapper, POI_OFF } from '../map/components/GoogleMap/GoogleMapWrapper.tsx'
import { updatedStyles } from '../map/components/GoogleMap/mapStyles.ts'

import '../map/map.css'
import { DEFAULT_ZOOM, HAWAII } from '../map/types.ts'
import { HistoryList } from './components/list/HistoryList.tsx'
import { ClusterMarker } from './components/markers/ClusterMarker.tsx'
import { HighlightMarker } from './components/markers/HighlightMarker.tsx'
import { HistoryControl } from './HistoryControl.tsx'
import { AnimatedMarker } from './components/movie/AnimatedMarker.tsx'
import { IPet, IPoint } from '../../interfaces/types.ts'
import movieStore from '../../store/movieStore.ts'
import { useLocation } from 'react-router-dom'
import { PetDrawer } from '../petDrawer/PetDrawer.tsx'
import { CenterMapButton } from '../common/buttons/CenterMapButton.tsx'
import { BackToMapBar } from './components/BackToMapBar'

export const HistoryMap: React.FC = () => {
    const location = useLocation()

    const map = historyStore((s) => s.map)
    const listRef = React.useRef(null)
    const controlRef = React.useRef(null)

    const mapStyle = mapStore(s => s.mapStyle)
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const isMovieMode = historyStore(s => s.isMovieMode)


    React.useEffect(() => {
        mapStore.getState().setMapContext('history')
        controlStore.getState().setCurrentPage('history')
        const pet = location?.state?.pet as IPet
        historyStore.getState().setSelectedPetId(pet?._id)

        return () => {
            window.removeEventListener("resize", handleResize);
            historyStore.getState().setLocations([])
            historyStore.getState().setHistoryPerPet({})
            historyStore.getState().setMarkers([])
            historyStore.getState().setIsMovieMode(false)
            historyStore.getState().setSelectedPetId('')
        }
    }, [])

    const handleResize = () => {
        setTimeout(() => {
            const styles = updatedStyles[mapStyle] ? [...(updatedStyles[mapStyle] as []), POI_OFF] :  updatedStyles.default
            map?.setOptions({styles})

            const bounds = new google.maps.LatLngBounds()
            let update = false
            if (!isMovieMode) {
                const locations = historyStore.getState().locations.filter(l => l.properties.status)
                locations.map((point: IPoint) => {
                    const latLng = new google.maps.LatLng({
                        lat: point.properties.latitude,
                        lng: point.properties.longitude,
                    })
                    bounds.extend(latLng)
                    update = true
                })
            } else {
                const locations = movieStore.getState().locations.filter(l => l.properties.status)
                if (locations?.[0]?.properties) {
                    const latLng = new google.maps.LatLng({
                        lat: locations[0].properties.latitude,
                        lng: locations[0].properties.longitude,
                    })
                    bounds.extend(latLng)
                    update = true
                }
            }
            if (update) {
                historyStore.getState().map?.fitBounds(bounds)
            }
        }, 200)
    };

    React.useEffect(() => {
        if (map) {
            const listener = window.google.maps.event.addListener(map, 'tilesloaded', function () {
                const styles = updatedStyles[mapStyle] ? [...(updatedStyles[mapStyle] as []), POI_OFF] :  updatedStyles.default
                map?.setOptions({styles})
                window.google.maps.event.removeListener(listener)
                window.addEventListener("resize", handleResize);
                if (!isMobile) {
                    window.dispatchEvent(new Event('resize'));
                }
            })
            const styles = updatedStyles[mapStyle] ? [...(updatedStyles[mapStyle] as []), POI_OFF] :  updatedStyles.default
            map?.setOptions({styles})

            // when the tiles are loaded the map will not be sized correctly for the window
            // to fix this we send a window resize event, but this has the side effect of moving the map back to default location
            // so we listen for the window resize, then move the map back to the history location
            //
            // window.dispatchEvent(new Event('resize'));
            // resizeMap()
        }
    }, [map])



    const googleMap =/* React.useMemo(() => {
        return*/ (
        <GoogleMapWrapper height="100%" center={HAWAII} zoom={DEFAULT_ZOOM} isHistory={true}>
            {!isMobile && isMovieMode ? <AnimatedMarker/> : <ClusterMarker/>}
            <HighlightMarker/>
            {isMobile ? (
                <div className={'absolute bottom-0 z-10'}>
                    <PetDrawer/>
                </div>
            ) : (
                null
            )}
            <div className={`absolute ${!isMobile ? 'bottom-[8rem] right-4' : 'bottom-[2rem] right-5'}`}>
                <CenterMapButton history/>
            </div>
        </GoogleMapWrapper>
    )
    /*}, [])*/

    const historyList = React.useMemo(() => <HistoryList listRef={listRef}/>, [])
    // const verticalList = React.useMemo(() =>  <VerticalList listRef={listRef}/>, [])

    const mobileMap = (
        <div>
            <div id={'history-map-mobile'} className={'mainMap relative'}>
                <div className={'absolute z-10 top-2'}>
                    <HistoryControl controlRef={controlRef} noPets={isMobile} showLabel/>
                </div>
                <div style={{height: '90vh'}}>
                    {googleMap}
                </div>
               {/* <div id={'drawer'} className={'absolute bottom-0 z-[100]'}>
                    <HistoryDrawer/>
                </div>*/}
            </div>
        </div>
    )

    const displayMap = (
        <div>
            <div id={'history-map'} className={'mainMap relative'}>
                {historyList}
                <HistoryControl controlRef={controlRef} noPets={isMobile} showLabel/>
                <div style={{height: 'calc(95vh - 170px)'}}>
                    {googleMap}
                </div>
                <BackToMapBar />
            </div>
        </div>
    )

    return isMobile ? mobileMap : displayMap
}

